import react from "./react.svg";
import nodejs from "./nodejs.svg";
import nextJs from "./nextJs.svg";
import typescript from "./typescript.svg";
import csharp from "./csharp.png";
import dotnet from "./dotnet.svg";
import cpp from "./cpp.svg";
import java from "./java.png";
import springboot from "./springboot.svg";
import python from "./python.png";
import postgres from "./postgres.png";
import laravel from "./laravel.svg";
import flutter from "./flutter.svg";
import powerBi from "./powerLogo.svg";
import grafana from "./grafana.svg";
import apachesuperset from "./apachesuperset.svg";
import docker from "./docker.svg";
import redis from "./redis.svg";
import rabbitmq from "./rabbitmq.svg";
import googlecloud from "./googlecloud.svg";
import amazonaws from "./amazonaws.svg";
import angular from "./angularJs.svg";
import figma from "./figma.svg";

/**
 * Technologies shown on the Services page.
 * Ordered to match MSD delivery stack from offers / industrial work.
 */
const technologiesLogos = [
  { name: "React", src: react },
  { name: "Next.js", src: nextJs },
  { name: "TypeScript", src: typescript },
  { name: "Node.js", src: nodejs },
  { name: "C#", src: csharp },
  { name: ".NET", src: dotnet },
  { name: "C++", src: cpp },
  { name: "Java", src: java },
  { name: "Spring Boot", src: springboot },
  { name: "Python", src: python },
  { name: "PostgreSQL", src: postgres },
  { name: "Laravel", src: laravel },
  { name: "Flutter", src: flutter },
  { name: "Docker", src: docker },
  { name: "Redis", src: redis },
  { name: "RabbitMQ", src: rabbitmq },
  { name: "Power BI", src: powerBi },
  { name: "Grafana", src: grafana },
  { name: "Apache Superset", src: apachesuperset },
  { name: "AWS", src: amazonaws },
  { name: "GCP", src: googlecloud },
  { name: "Angular", src: angular },
  { name: "Figma", src: figma },
];

export default technologiesLogos;
